

(function () {

    angular.module('tmx-common').directive('tmxPiechart', tmxPiechart);

    function tmxPiechart() {

        return {
            scope: {
                data: "=",
                field: "@",
                dir: "@",
                type: "@",
                series: "=",
                title: "@",
                categories: "=",
                stack: "@",
                filter:'=?',
                seriesColors:'=?'
            },
            require: 'ngModel',
            restrict: 'E',
            templateUrl: 'common/directives/tmxpiechart/tmxpiechart.html',
            controller: tmxPiechartCtrl,
            controllerAs: 'PieChartCtrl'

        }
    }
    function tmxPiechartCtrl($scope, $rootScope,APP_CONSTANTS) {
        $scope.onSeriesHover = function (e) {
            kendoConsole.log(kendo.format("event :: seriesHover ({0} : {1})", e.series.name, e.value));
        };

        var tmxPiechartVM = this;
        tmxPiechartVM.title = $scope.title;
        tmxPiechartVM.series = $scope.series;
        tmxPiechartVM.seriesColors = $scope.seriesColors;
        tmxPiechartVM.categories = $scope.categories;
        tmxPiechartVM.type = $scope.type;
        tmxPiechartVM.filter = $scope.filter;
        tmxPiechartVM.filterChanged = function(selectedValue){
            if(selectedValue){
                tmxPiechartVM.dataSource.options.transport.read.url = getDataUrl(selectedValue);
                tmxPiechartVM.dataSource.read();
            }
        }
        tmxPiechartVM.tooltip = "{ visible: 'true', template: '#= series.name #' }"
        tmxPiechartVM.dataSource = new kendo.data.DataSource({
            transport: {
                read: {
                    url: tmxPiechartVM.filter ? getDataUrl(tmxPiechartVM.filter.selectedValue):getDataUrl(),
                    dataType: "json",
                    beforeSend: function (req) {
                        req.setRequestHeader('Offset', 100);
                    }
                }
            },
            sort: {
                field: $scope.field,
                dir: $scope.dir
            }
        });
        tmxPiechartVM.myStyle={"width":tmxPiechartVM.width,"height":tmxPiechartVM.height}
        tmxPiechartVM.chartOptions = /* chart data*/
            {
                // "title": {
                //     "text": tmxPiechartVM.title,
                //     "position": "bottom"
                // },
                "legend": {
                    "visible": true,
                },
              
                "chartArea": {
                    "background": ""
                },
                "seriesDefaults": {
                    "type": "pie",
                    "explode": true
                },

                "series": tmxPiechartVM.series,
                "seriesColors": tmxPiechartVM.seriesColors,//["#e67300","#ff8080","#59b300","#1a53ff","#4d0000","#b3ff66","#666699","#bfbfbf","#ffb3e6","#ffb366","#001a66"],
               
                "dataSource": tmxPiechartVM.dataSource,
                "tooltip": {
                    "visible": true,
                    "template": function(dataItem){
                        return `${dataItem.category}: ${dataItem.value}` 
                    } 
                },
                "filter":
                {
                    "field":$scope.field,
                    "operator":"eq"
                   
                },
                "chartArea":
                {
                    "background":"#FFFFFF"
                    // "background": "red"
                }

            }
        
        function getDataUrl(selectedValue){
            if(tmxPiechartVM.filter&& tmxPiechartVM.filter.show){
                return APP_CONSTANTS.backend + $scope.data+"/"+selectedValue;
            }
            return APP_CONSTANTS.backend + $scope.data
        }
       
    }

})();